//UserAvatar
import React from 'react';

import { Avatar, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
        color: 'black',
        backgroundColor : '#fe752f',
        marginRight : '2vw',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
      }
}))

export const UserAvatar = function UserAvatar(props) {

    const classes = useStyles();

    return(
        <Avatar alt={props.userName} className={classes.large} >{ props.userName != null ? props.userName[0].toUpperCase() : 'D' }</Avatar>
    )

}